import React from 'react';
import ToolCard from '../../components/ToolCard';

const EntrepriseTools = ({ userPlan }) => {
  return (
    <div className="enterprise-tools grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <ToolCard 
        title="Solutions personnalisées" 
        description="Des solutions sur mesure adaptées à votre entreprise." 
      />
      <ToolCard 
        title="Intégrations API" 
        description="Connectez vos systèmes à notre IA via API." 
      />
      <ToolCard 
        title="Support prioritaire" 
        description="Assistance prioritaire 24/7 pour votre équipe." 
      />
      <ToolCard 
        title="Comptes multiples" 
        description="Gérez plusieurs utilisateurs dans votre entreprise." 
      />
    </div>
  );
};

export default EntrepriseTools;
